import FileUpload from "./KrFileUpload.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrFileUpload = install(FileUpload); // 生成带有 install 方法的组件

export default KrFileUpload;
